export default "Questa vista offre una panoramica riassuntiva sul **Report Code**, sono sempre esclusi i dati del giorno corrente.\n";